<template>
    <div class="container-top gray">
        <div class="container-center max">
            <page-header></page-header>
            <div class="container-main pa0">
                <div class="wrap-partner-join complete">
                    <div class="logo-join-partner"></div>
                    <div class="title-join-partner">이웃 파트너 가입이 완료되었습니다.</div>
                    <div class="subtitle-join-partner">지금부터 다양한 콘텐츠를 업로드 해보세요!</div>
                    <div>
                        <button
                            class="button-join-partner"
                            @click="$router.push('/partner')"
                        >이웃파트너 페이지로 이동</button>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import PageFooter from "@/components/PageFooter.vue";

export default {
    name: "PartnerJoinComplete",
    mixins: [],
    components: {
        PageHeader,
        PageFooter
    },
    inject: [],
    provide() {
        return {};
    },
    props: {},
    data() {
        return {};
    },
    beforeRouterEnter() {},
    created() {},
    mounted() {},
    beforeDestroy() {},
    destroyed() {},
    computed: {},
    methods: {},
    watch: {},
};
</script>

<style scoped></style>